import script from "./PopupTool8.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool8.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool8.vue?vue&type=style&index=0&id=03cb9337&lang=scss&scoped=true"
import "./PopupTool8.vue?vue&type=style&index=1&id=03cb9337&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cb9337"]])

export default __exports__